import React from 'react'
import SimpleTableTable from './../../../../../Components/SimpleTableTable'
import { Link } from 'react-router-dom'
import {
  dropTimeZoneFromDate,
  getShortTime,
  getDescriptiveDate,
  getShortWeekDay,
} from './../../../../../shared/libraries/utils/date'

const Missions = props => {
  return (
    <div style={{ height: 350, border: '1px solid #f2f4f6', overflow: 'auto' }}>
      <SimpleTableTable
        header={[
          '#MISSION',
          'CAMPAIGN NAME',
          'DATE',
          'TIME',
          'AMBASSADOR',
          'SCHEDULED PICKUP TIME',
        ]}
        data={props.missions}
        sortOn={[
          '#MISSION',
          'CAMPAIGN NAME',
          'DATE',
          'TIME',
          'AMBASSADOR',
          'SCHEDULED PICKUP TIME',
        ]}
        postRowRender={m => ({
          ...m,
          '#MISSION': (
            <Link to={`/dashboard/mission/${m['#MISSION']}`}>
              <span style={{ textDecoration: 'underline' }}>
                {m['#MISSION']}
              </span>
            </Link>
          ),
          'SCHEDULED PICKUP TIME': formatDateTime(m['SCHEDULED PICKUP TIME']),
        })}
      />
    </div>
  )
}

export default Missions

/**
 * Formats a date time into a readable string suitable for the mission pickup
 * date.
 * @param {Date} pickupDateTime
 * @returns {string}
 */
function formatDateTime(pickupDateTime) {
  if (!pickupDateTime) return 'No time specified'
  var pickupDateTime = new Date(dropTimeZoneFromDate(pickupDateTime))
  return (
    getShortWeekDay(pickupDateTime.getDay()) +
    ' ' +
    getDescriptiveDate(pickupDateTime.getDate()) +
    ' ' +
    getShortTime(pickupDateTime)
  )
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/MissionsTable/index.js